// src/uid.ts
import { uid } from "uid/secure";

// src/entity.ts
function newId() {
  return uid(10);
}
function same(left, right) {
  if (left === right) return true;
  if (!left) return !right;
  if (!right) return false;
  return left.id === right.id;
}

// src/utils.ts
function noop() {
}
function defaultTo(d, v) {
  return v == null || v !== v ? d : v;
}
function pick(keys, target) {
  return keys.reduce((acc, key) => {
    if (target.hasOwnProperty(key)) return acc;
    if (target[key] !== null && typeof target[key] !== "undefined") {
      acc[key] = target[key];
    }
    return acc;
  }, {});
}
function recursiveDeepCopy(o) {
  let newO, i;
  if (typeof o !== "object") {
    return o;
  }
  if (!o) {
    return o;
  }
  if (Array.isArray(o)) {
    newO = [];
    for (i = 0; i < o.length; i += 1) {
      newO[i] = recursiveDeepCopy(o[i]);
    }
    return newO;
  }
  newO = {};
  for (i in o) {
    if (o.hasOwnProperty(i)) {
      newO[i] = recursiveDeepCopy(o[i]);
    }
  }
  return newO;
}
function clean(o) {
  const obj = Object.assign({}, o);
  const propNames = Object.getOwnPropertyNames(obj);
  for (let i = 0; i < propNames.length; i++) {
    const propName = propNames[i];
    if (obj[propName] === null || obj[propName] === void 0) {
      delete obj[propName];
    }
  }
  return obj;
}
function arrayToRecord(arr) {
  return arr.reduce(
    (res, item) => ({
      ...res,
      [item.id]: item
    }),
    {}
  );
}
function recordToArray(record, sort) {
  const arr = Object.values(record);
  if (sort) {
    arr.sort(sort);
  }
  return arr;
}

export {
  uid,
  newId,
  same,
  noop,
  defaultTo,
  pick,
  recursiveDeepCopy,
  clean,
  arrayToRecord,
  recordToArray
};
